import { fonts, purify } from '@vfit/shared/themes';
import { CustomText, Svg } from '@vfit/shared/atoms';
import { useState } from 'react';
import {
  OptionContainer,
  DisclaimerContainer,
  ModalContent,
  ModalTitle,
  ProductCardSpecItemAction,
  Title,
  Disclaimer,
} from './option.style';
import { IOption } from './option.models';
import { VfModal } from '@vfit/shared/components';
import { trackView } from '@vfit/shared/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';

const Option = ({
  optionTitle,
  popup,
  color,
  optionDisclaimer,
  popupTitle,
  compactStyle,
  isGlobalPromo = false,
  productId,
  productName,
  productCategory,
  productPrice,
}: IOption) => {
  const [pOptionTitle, pOptionDisclaimer] = purify([optionTitle || '', optionDisclaimer || '']);
  const [modal, setModal] = useState({
    show: false,
    text: '',
    title: '',
  });

  const openModal = () => {
    trackView({
      event_name: 'view',
      event_label_track: 'offer detail',
      event_category: 'sales',
      tracking_type: 'view',
      journey_type: 'task',
      page_type: 'popup',
      page_subsection: 'offer detail',
      ...(productCategory && { product_category: productCategory }),
      ...(productPrice && { product_price: removeCurrency(productPrice) }),
      ...(productId && { product_id: productId }),
      ...(productName && { product_name: productName }),
      product_target_segment: 'consumer',
      product_quantity: '1',
    });
    setModal({
      title: popupTitle || pOptionTitle || '',
      text: popup,
      show: true,
    });
  };

  const closeModal = () => {
    setModal({ show: false, text: '', title: '' });
  };

  return (
    <>
      <OptionContainer compact={compactStyle} isGlobalPromo={isGlobalPromo}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <DisclaimerContainer>
            {optionDisclaimer && (
              <Disclaimer dangerouslySetInnerHTML={{ __html: pOptionDisclaimer || '' }} />
            )}
          </DisclaimerContainer>
          <Title
            style={{ color: `${color}` }}
            dangerouslySetInnerHTML={{
              __html: pOptionTitle || '',
            }}
            isGlobalPromo={isGlobalPromo}
          />
        </div>
        {popup && (
          <div className="tooltip" role="presentation" onClick={openModal}>
            <ProductCardSpecItemAction>
              <Svg name="info" height={16} width={16} />
            </ProductCardSpecItemAction>
          </div>
        )}
      </OptionContainer>

      <VfModal height={563} isOpen={modal.show} handleClose={closeModal}>
        <>
          {modal.title && (
            <ModalTitle>
              <CustomText fontFamily={fonts.exbold} textAlign="left" text={modal.title} />
            </ModalTitle>
          )}
          <ModalContent>
            <CustomText size={20} lineHeight={24} textAlign="left" text={modal.text} />
          </ModalContent>
        </>
      </VfModal>
    </>
  );
};

export default Option;
